import mainFaqData from '../../assets/data/mainFaq.json';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './HomeMobile.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import rightArrow from '../../assets/rightArrow.png';
import MainFaqFrameMobile from '../../mobileComponents/MainFaqFrameMobile/MainFaqFrameMobile';
import MainReviewFrame from '../../components/MainReviewFrame/MainReviewFrame';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import LazyLoad from 'react-lazy-load';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { loginCheck } from '../../auth/auth';
import ReviewFilter from '../../components/ReviewFilter/ReviewFilter';
import banner02 from '../../assets/bannerImage02.png';
import subBanner from '../../assets/banner/subBanner.jpeg';
import processImage01 from '../../assets/processImage01.png';
import processImage02 from '../../assets/processImage02.png';
import processImage03 from '../../assets/processImage03.png';
import country01 from '../../assets/country/country1.png';
import country02 from '../../assets/country/country2.png';
import country03 from '../../assets/country/country3.png';
import country04 from '../../assets/country/country4.png';
import doctor02 from '../../assets/doctors/doctor02.png';
import youjiyou from '../../assets/doctors/youjiyou.png';
import kimmiri from '../../assets/doctors/kimmiri.png';
import star from '../../assets/star.png';
import america from '../../assets/america.png';
import { IProductListType } from '../../pages/ProductList/ProductList';
import banner from '../../assets/banner/mobileMainBanner.jpeg';
import banner2 from '../../assets/banner/mobileMainBanner02.jpeg';
import process01 from '../../assets/process01.png';
import process02 from '../../assets/process02.png';
import process03 from '../../assets/process03.png';
import process04 from '../../assets/process04.png';
import { useTranslation } from 'react-i18next';
import Popup from '../../components/Popup/Popup';
const countryList = [country01, country02, country03, country04];

const imsiSliderList = [banner2];

const mainFaqList = mainFaqData;
function HomeMobile() {
  const location = useLocation();
  const navigate = useNavigate();
  //배너
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  //배너
  //상품
  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      let queryString = '';
      let ids = JSON.parse(
        sessionStorage.getItem('product_ids') || JSON.stringify([]),
      );
      if (ids.length) {
        queryString = 'add_products=';
        ids.map((id: number, idx: number) => {
          queryString += `${id}${idx !== ids.length - 1 ? ',' : ''}`;
        });
      }
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
    {
      staleTime: 60000 * 60 * 24,
    },
  );
  //상품
  //프로세스
  const [processSliderIdx, setProcessSliderIdx] = useState(0);
  //프로세스
  //faq
  // const { data: faqListQuery } = useQuery<{
  //   data: IFaqType[];
  //   faq_type: {
  //     [key: number]: string;
  //   };
  // }>('faq', () => axiosClient.get('/data/faq').then((res) => res.data.data), {
  //   staleTime: 60000 * 60 * 24, //1일 캐싱
  // });
  //faq
  //review
  // const [reviewData, setReviewData] = useState<IReviewDataType[]>([]);
  // useEffect(() => {
  //   axiosClient
  //     .get('/data/product_talk/list?&talk_type=상품평가&limit=5&order_by=star')
  //     .then((res) => setReviewData(res.data.data));
  // }, []);
  const { data: reviewData } = useQuery<IReviewDataType[]>(
    ['main', 'photo_review'],
    () =>
      axiosClient
        .get(
          '/data/product_talk/photo-review-list?&talk_type=상품평가&limit=5&order_by=star',
        )
        .then((res) => res.data.data),
    {
      staleTime: 60000 * 60,
    },
  );
  //review
  //doctor
  const [doctorSliderIdx, setDoctorSliderIdx] = useState(0);
  //doctor

  const handleBannerClick = (productId: number) => {
    navigate(`/productDetail/${productId}`);
  };

  //기존 상품 url접속시 대응
  useEffect(() => {
    let pn = new URLSearchParams(location.search).get('pn');
    if (!pn) return;
    if (pn == 'product.view') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=N&code=${new URLSearchParams(
            location.search,
          ).get('pcode')}`,
        )
        .then((res) => navigate(res.data.data.url));
    } else if (pn == 'blind_gate') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=Y&code=${new URLSearchParams(
            location.search,
          ).get('bc')}`,
        )
        .then((res) => navigate(res.data.data.url));
    }
  }, []);
  //기존 상품 url접속시 대응
  const { t, i18n } = useTranslation();
  return (
    <div>
      <Header />
      {/* <Popup /> */}
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {imsiSliderList.map((banner, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={banner}
                alt="banner"
                onClick={() => handleBannerClick(2)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <ul className={styles.paginationWrap}>
          {imsiSliderList.map((banner, idx) => (
            <li
              key={idx}
              onClick={() => swiper?.slideTo(idx, 200)}
              className={idx == activeIdx ? styles.hit : ''}
            ></li>
          ))}
        </ul>
      </div>
      {/* <div className={styles.processInfoWrap}>
        <h3>{t('home.1')}</h3>
        <p>{t('home.2')}</p>
        <ul>
          <li># {t('home.3')}</li>
          <li># {t('home.5')}</li>
          <li># {t('home.4')}</li>
        </ul>
        <div className={styles.processSliderWrap}>
          <Swiper
            slidesPerView={1}
            spaceBetween={21}
            className={styles.processSlider}
            onSlideChange={(e) => setProcessSliderIdx(e.activeIndex)}
          >
            <SwiperSlide className={styles.processSlide}>
              <img src={process01} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.6')}</h4>
                <p>{t('home.7')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process02} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.8')}</h4>
                <p>{t('home.9')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process03} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.10')}</h4>
                <p>{t('home.11')}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.processSlide}>
              <img src={process04} alt="process" />
              <div className={styles.stage}>
                <h4>{t('home.12')}</h4>
                <p>{t('home.13')}</p>
              </div>
            </SwiperSlide>
          </Swiper>
          <ul className={styles.processSliderPagination}>
            {(() => {
              let list = [0, 1, 2, 3];
              return list.map((val) => (
                <li
                  key={val}
                  className={processSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul>
        </div>
      </div> */}
      <div className={styles.worldPlatform}>
        <h3
          dangerouslySetInnerHTML={{
            __html: t('home.59').replace(/<br \/>/gi, ''),
          }}
        ></h3>
        <ul>
          {countryList.map((country, idx) => (
            <li key={idx}>
              <img src={country} />
            </li>
          ))}
        </ul>
        <p>{t('home.60')}</p>
      </div>
      {/* <div className={styles.prescriptionProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=487`)}>
          <span>{t('home.14')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.15')}</span>
        <Swiper
          slidesPerView={1.1}
          spaceBetween={10}
          className={styles.prescriptionProductSlider}
        >
          {productList
            ?.filter((product) => product.is_prescription == 1)
            .map((product) => (
              <SwiperSlide
                key={product.product_id}
                className={styles.prescriptionProductSlide}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <img src={product.list_image} alt="productThumbnail" />
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag) => <li># {hashtag}</li>)}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <div className={styles.normalProductWrap}>
        <h3 onClick={() => navigate(`/productList?cuid=488`)}>
          <span>{t('home.16')}</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.17')}</span>
        <ul className={styles.normalProductList}>
          {productList
            ?.filter((product) => product.is_prescription == 0)
            .filter((product, idx) => idx == 0)
            .map((product) => (
              <li
                key={product.product_id}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div className={styles.productThumbnailWrap}>
                  <img src={product.list_image} alt="productThumbnail" />
                </div>
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  <ul className={styles.hashtagList}>
                    {product.hashtag &&
                      product.hashtag
                        .split(',')
                        .map((hashtag, idx) => <li key={idx}>{hashtag}</li>)}
                  </ul>
                </div>
              </li>
            ))}
        </ul>
      </div> */}
      <div className={styles.allProductList}>
        <h3>
          <span>DIET DOCTOR PRODUCT</span>
        </h3>
        <span>{t('home.18')}</span>
        <ul className={styles.productListWrap}>
          {productList
            ?.filter((product, idx) => idx < 4)
            .map((product) => (
              <li
                key={product.product_id}
                onClick={() => navigate(`/productDetail/${product.product_id}`)}
              >
                <div className={styles.productThumbnailWrap}>
                  <img
                    src={product.list_image + '?w=530'}
                    alt="productThumbnail"
                  />
                </div>
                <div className={styles.productInfoWrap}>
                  <h3>{product.title}</h3>
                  {product.discount_rate !== 0 && (
                    <span className={styles.discountRate}>
                      {product.discount_rate}%
                    </span>
                  )}
                  <span className={styles.price}>
                    ${product.discount_price.toLocaleString()}
                  </span>
                  <div className={styles.reviewScore}>
                    <img src={star} alt="star" />
                    <span>
                      {Math.floor(
                        (product.review_score_avg.review_point_total_avg / 2) *
                          10,
                      ) / 10}
                    </span>
                  </div>
                </div>
              </li>
            ))}
        </ul>
        {productList && productList.length > 4 && (
          <button onClick={() => navigate(`/productList`)}>
            {t('home.19')}
          </button>
        )}
      </div>
      <div className={styles.faqWrap}>
        <h3 onClick={() => navigate(`/faq`)}>
          <span>DIET DOCTOR FAQ</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.20')}</span>
        <ul>
          {mainFaqList.map((faq, idx) => (
            <MainFaqFrameMobile faq={faq} key={idx} />
          ))}
        </ul>
      </div>
      <div className={styles.reviewWrap}>
        <h3 onClick={() => navigate(`/review/all`)}>
          <span>DIET DOCTOR REVIEW</span>
          <img src={rightArrow} alt="rightArrow" />
        </h3>
        <span>{t('home.21')}</span>
        <div className={styles.reviewSliderWrap}>
          <LazyLoad>
            <Swiper
              slidesPerView={1.2}
              spaceBetween={10}
              className={styles.reviewSlider}
              breakpoints={{ 700: { slidesPerView: 2.8 } }}
            >
              {reviewData
                ?.filter((review) => review.product?.list_image)
                .map((review) => (
                  <SwiperSlide key={review.id}>
                    <MainReviewFrame review={review} />
                  </SwiperSlide>
              ))}
            </Swiper>
          </LazyLoad>
          {/* {!loginCheck() && <ReviewFilter borderRadius={0} />} */}
        </div>
      </div>
      {/* <div className={styles.ondocInfoWrap}>
        <ul>
          <li>
            <h3>{t('home.22')}</h3>
            <p>{t('home.23')}</p>
            <img src={processImage01} alt="processImage" />
          </li>
          <li>
            <h3>{t('home.24')}</h3>
            <p>{t('home.25')}</p>
            <img src={processImage02} alt="processImage" />
          </li>
          <li>
            <h3>{t('home.26')}</h3>
            <p>{t('home.27')}</p>
            <img src={processImage03} alt="processImage" />
          </li>
        </ul>
      </div> */}
      <div>
        <img src={subBanner} alt="sub_banner" style={{ width: '100%' }} />
      </div>
      <div className={styles.legitScript}>
        <img src={america} alt="america" />
        <div>
          <img
            src="	https://static.legitscript.com/seals/14145209.png"
            alt="legit"
          />
          <p>{t('home.58')}</p>
          <p>
            DIET DOCTOR started with US legitScript
            <br />
            contactless medical certification has been obtained.
          </p>
        </div>
      </div>
      <div className={styles.doctorInfoWrap}>
        <h3>DIET DOCTOR - DOCTORS</h3>
        <p>{t('home.28')} </p>
        <div className={styles.doctorSliderWrap}>
          <Swiper
            slidesPerView={1}
            spaceBetween={21}
            className={styles.doctorSlider}
            onSlideChange={(e) => setDoctorSliderIdx(e.activeIndex)}
          >
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img src={doctor02} alt="process" />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.29')}</h4>
                <span>Lee Soyoung</span>
                <ul>
                  <li>{t('home.30')}</li>
                  <li>{t('home.31')}</li>
                  <li>{t('home.32')}</li>
                  <li>{t('home.33')}</li>
                  <li>{t('home.34')}</li>
                  <li>{t('home.35')}</li>
                  <li>{t('home.36')}</li>
                </ul>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img
                  src={youjiyou}
                  alt="process"
                  style={{ maxWidth: '151px' }}
                />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.37')}</h4>
                <span>Yoo jiyou</span>
                <ul>
                  <li>{t('home.38')}</li>
                  <li>{t('home.39')}</li>
                  <li>{t('home.40')}</li>
                  <li>{t('home.41')}</li>
                  <li>{t('home.42')}</li>
                </ul>
              </div>
            </SwiperSlide>
            <SwiperSlide className={styles.doctorSlide}>
              <div className={styles.doctorImageWrap}>
                <img
                  src={kimmiri}
                  alt="process"
                  style={{
                    maxWidth: '183px',
                    objectPosition: 'top',
                  }}
                />
              </div>
              <div className={styles.doctorInfo}>
                <h4>{t('home.43')}</h4>
                <span>Kim miri</span>
                <ul>
                  <li>{t('home.44')}</li>
                  <li>{t('home.45')}</li>
                  <li>{t('home.46')}</li>
                  <li>{t('home.47')}</li>
                  <li>{t('home.48')}</li>
                </ul>
              </div>
            </SwiperSlide>
          </Swiper>
          <ul className={styles.doctorSliderPagination}>
            {(() => {
              let list = [0, 1, 2];
              return list.map((val) => (
                <li
                  key={val}
                  className={doctorSliderIdx == val ? styles.hit : ''}
                >
                  <div></div>
                </li>
              ));
            })()}
          </ul>
        </div>
      </div>
      <div className={styles.ondocService}>
        <img src={banner02} alt="banner" />
        <div className={styles.textWrap}>
          <p>{t('home.56')}</p>
          <p>{t('home.57')}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default HomeMobile;
